export default __webpack_public_path__ + "static/28-flash-drive-2e795708493a158fde94b1c2480455e0.png";